import { render, staticRenderFns } from "./DateTextField.vue?vue&type=template&id=2831c9f6&"
import script from "./DateTextField.vue?vue&type=script&lang=js&"
export * from "./DateTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports